const isRepeated = value => /^(.)\1*$/.test(value);

export default isRepeated;
